import axios from "axios";
import { user } from "./apiconfig/rest_apis.js";
import { header } from "./apiconfig/header.js";

const login = (data) => {
  return axios({
    url: user.LOGIN_URL,
    method: "post",
    data: data,
  });
};

const validateToken = () => {
  return axios({
    url: user.VALIDATE_TOKEN,
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
};

const userList = (userType) => {
  console.log(userType);
  return axios({
    url: user.USER + "?user_type=" + userType,
    method: "get",
    headers: header,
  });
};

const userProfileList = (userType) => {
  console.log(userType);
  return axios({
    url: user.USER_PROFILE_LIST + "?user_type=" + userType,
    method: "get",
    headers: header,
  });
};

const searchTextList = (searchText) => {
  return axios({
    url: user.GET_SEARCH_TEXT_LIST + "?search_text=" + searchText,
    method: "get",
    headers: header,
  });
};

const create = (data) => {
  return axios({
    url: user.USER,
    method: "post",
    data: data,
    headers: header,
  });
};

const updateUser = (data) => {
  console.log(data._id);
  return axios({
    url: user.USER + "/" + data._id,
    method: "put",
    data: data,
    headers: header,
  });
};

const getMyProfile = (data) => {
  return axios({
    url: user.GET_MY_PROFILE,
    method: "get",
    headers: header,
  });
};

const getUserProfile = (data) => {
  return axios({
    url: user.GET_USER_PROFILE,
    method: "get",
    headers: header,
  });
};

const updateFullname = (data) => {
  return axios({
    url: user.USER + "/" + data.userId,
    method: "put",
    data: data,
    headers: header,
  });
};

const getCustomerData = (data) => {
  return axios({
    url: user.GET_CUSTOMER_DATA,
    method: "post",
    data: data,
    headers: header,
  });
};

const updateCustomerData = (data) => {
  console.log("user.UPDATE_CUSTOMER_DATA");
  console.log(user.UPDATE_CUSTOMER_DATA);
  console.log("user.UPDATE_CUSTOMER_DATA");
  return axios({
    url: user.UPDATE_CUSTOMER_DATA,
    method: "post",
    data: data,
    headers: header,
  });
};

const getEmpDocs = (data) => {
  return axios({
    url: user.GET_EMP_DOCS+"/"+data.employeeId,
    method: "get",
    headers: header,
  });
};

export const userService = {
  login,
  validateToken,
  userList,
  userProfileList,
  searchTextList,
  create,
  updateUser,
  getMyProfile,
  getUserProfile,
  getCustomerData,
  updateCustomerData,
  getEmpDocs,
};
